import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { getOptionLabel } from "common/enums";

const NUMBERS_TO_DISPLAY = 6;

const ConsumerNumbersDisplay = ({ consumerNumbers = [] }) => {
  const [showMore, setShowMore] = useState(false);

  const displayedNumbers = useMemo(
    () =>
      showMore ? consumerNumbers : consumerNumbers.slice(0, NUMBERS_TO_DISPLAY),
    [showMore, consumerNumbers]
  );

  return (
    <Box>
      <Typography sx={{ display: "inline" }} variant="body2">
        {displayedNumbers
          .map(
            (item) =>
              `${item.consumerNumber} : ${getOptionLabel("utilityOptions", item.utilityId)}`
          )
          .join(", ")}
      </Typography>

      {consumerNumbers.length > NUMBERS_TO_DISPLAY && (
        <Typography
          sx={{ cursor: "pointer", fontSize: "14px" }}
          onClick={() => setShowMore((prev) => !prev)}
        >
          {showMore ? (
            <>
              Show Less <KeyboardArrowUp />
            </>
          ) : (
            <>
              Show More <KeyboardArrowDown />
            </>
          )}
        </Typography>
      )}
    </Box>
  );
};

ConsumerNumbersDisplay.propTypes = {
  consumerNumbers: PropTypes.array,
};

export default ConsumerNumbersDisplay;
